import { DigiResEnvironmentName } from '../../environments/EnvironmentTypes';
import { BY_ALPHA_2 } from '../shared/model/geo/Countries';
import { CountryAlpha2Code } from '../shared/model/geo/CountryAlpha2Code';

export enum FncGroup {
  USER = 'USER',
  PROJECT_CREATOR = 'PROJECT_CREATOR',
  PROJECTS_READING_ACCESS = 'PROJECTS_READING_ACCESS',
  PROJECTS_WRITING_ACCESS = 'PROJECTS_WRITING_ACCESS',
  ACQUISITION = 'ACQUISITION',
  ACQUISITION_READING_ACCESS = 'ACQUISITION_READING_ACCESS',
  ADMIN = 'ADMIN',
  PROCESS_ADMIN = 'PROCESS_ADMIN',
  IT_SUPPORT = 'IT_SUPPORT',
  TEST_USER = 'TEST_USER',

  BUSINESS_ADMIN_PROD_DE = 'BUSINESS_ADMIN_PROD_DE',
  BUSINESS_ADMIN_PROD_FR = 'BUSINESS_ADMIN_PROD_FR',
  BUSINESS_ADMIN_PROD_IT = 'BUSINESS_ADMIN_PROD_IT',
  BUSINESS_ADMIN_PROD_AU = 'BUSINESS_ADMIN_PROD_AU',
  BUSINESS_ADMIN_PROD_PL = 'BUSINESS_ADMIN_PROD_PL',
  BUSINESS_ADMIN_PROD_GB = 'BUSINESS_ADMIN_PROD_GB',
  BUSINESS_ADMIN_PROD_NL = 'BUSINESS_ADMIN_PROD_NL',
  BUSINESS_ADMIN_PROD_ES = 'BUSINESS_ADMIN_PROD_ES',
  BUSINESS_ADMIN_PROD_IE = 'BUSINESS_ADMIN_PROD_IE',

  BUSINESS_ADMIN_UAT_DE = 'BUSINESS_ADMIN_UAT_DE',
  BUSINESS_ADMIN_UAT_FR = 'BUSINESS_ADMIN_UAT_FR',
  BUSINESS_ADMIN_UAT_IT = 'BUSINESS_ADMIN_UAT_IT',
  BUSINESS_ADMIN_UAT_AU = 'BUSINESS_ADMIN_UAT_AU',
  BUSINESS_ADMIN_UAT_PL = 'BUSINESS_ADMIN_UAT_PL',
  BUSINESS_ADMIN_UAT_GB = 'BUSINESS_ADMIN_UAT_GB',
  BUSINESS_ADMIN_UAT_NL = 'BUSINESS_ADMIN_UAT_NL',
  BUSINESS_ADMIN_UAT_ES = 'BUSINESS_ADMIN_UAT_ES',
  BUSINESS_ADMIN_UAT_IE = 'BUSINESS_ADMIN_UAT_IE',

  BUSINESS_ADMIN_TEST_ANY = 'BUSINESS_ADMIN_TEST_ANY',

  COUNTRY_READING_AU = 'COUNTRY_READING_AU',
  COUNTRY_READING_FR = 'COUNTRY_READING_FR',
  COUNTRY_READING_DE = 'COUNTRY_READING_DE',
  COUNTRY_READING_GR = 'COUNTRY_READING_GR',
  COUNTRY_READING_IE = 'COUNTRY_READING_IE',
  COUNTRY_READING_IT = 'COUNTRY_READING_IT',
  COUNTRY_READING_NL = 'COUNTRY_READING_NL',
  COUNTRY_READING_PL = 'COUNTRY_READING_PL',
  COUNTRY_READING_ES = 'COUNTRY_READING_ES',
  COUNTRY_READING_SE = 'COUNTRY_READING_SE',
  COUNTRY_READING_GB = 'COUNTRY_READING_GB',

  BINARY_ASSESSMENT_READING_AU = 'BINARY_ASSESSMENT_READING_AU',
  BINARY_ASSESSMENT_WRITING_AU = 'BINARY_ASSESSMENT_WRITING_AU',
  BINARY_ASSESSMENT_READING_FR = 'BINARY_ASSESSMENT_READING_FR',
  BINARY_ASSESSMENT_WRITING_FR = 'BINARY_ASSESSMENT_WRITING_FR',
  BINARY_ASSESSMENT_READING_DE = 'BINARY_ASSESSMENT_READING_DE',
  BINARY_ASSESSMENT_WRITING_DE = 'BINARY_ASSESSMENT_WRITING_DE',
  BINARY_ASSESSMENT_READING_GR = 'BINARY_ASSESSMENT_READING_GR',
  BINARY_ASSESSMENT_WRITING_GR = 'BINARY_ASSESSMENT_WRITING_GR',
  BINARY_ASSESSMENT_READING_IE = 'BINARY_ASSESSMENT_READING_IE',
  BINARY_ASSESSMENT_WRITING_IE = 'BINARY_ASSESSMENT_WRITING_IE',
  BINARY_ASSESSMENT_READING_IT = 'BINARY_ASSESSMENT_READING_IT',
  BINARY_ASSESSMENT_WRITING_IT = 'BINARY_ASSESSMENT_WRITING_IT',
  BINARY_ASSESSMENT_READING_NL = 'BINARY_ASSESSMENT_READING_NL',
  BINARY_ASSESSMENT_WRITING_NL = 'BINARY_ASSESSMENT_WRITING_NL',
  BINARY_ASSESSMENT_READING_PL = 'BINARY_ASSESSMENT_READING_PL',
  BINARY_ASSESSMENT_WRITING_PL = 'BINARY_ASSESSMENT_WRITING_PL',
  BINARY_ASSESSMENT_READING_ES = 'BINARY_ASSESSMENT_READING_ES',
  BINARY_ASSESSMENT_WRITING_ES = 'BINARY_ASSESSMENT_WRITING_ES',
  BINARY_ASSESSMENT_READING_SE = 'BINARY_ASSESSMENT_READING_SE',
  BINARY_ASSESSMENT_WRITING_SE = 'BINARY_ASSESSMENT_WRITING_SE',
  BINARY_ASSESSMENT_READING_GB = 'BINARY_ASSESSMENT_READING_GB',
  BINARY_ASSESSMENT_WRITING_GB = 'BINARY_ASSESSMENT_WRITING_GB',
}

export const fncGroupToDescription: Record<FncGroup, string> = {
  USER: 'You have the normal DigiRES-OPEA access rights',
  TEST_USER: 'You have the right to access the DigiRES-OPEA Test Environments (Staging, Feature Preview and Debug.)',
  PROJECT_CREATOR: 'You have the right to create projects in DigiRES-OPEA',
  PROJECTS_READING_ACCESS: 'You have the right to read all project information in DigiRES-OPEA',
  PROJECTS_WRITING_ACCESS: 'You have the right to edit all project information in DigiRES-OPEA',
  ACQUISITION: 'You have the right to access the Acquisition Module in DigiRES-OPEA',
  ACQUISITION_READING_ACCESS: 'You have the right to read all opportunity and project information in the Acquisition Module in DigiRES-OPEA',
  PROCESS_ADMIN: 'You have the right to access the Admin Area in the Process Module of DigiRES-OPEA',
  ADMIN: 'You have the right to access the Admin Area in DigiRES-OPEA',
  IT_SUPPORT: 'You have the right to access and make edits in all areas of DigiRES-OPEA',
  BUSINESS_ADMIN_PROD_DE: 'You have the right to edit all project information in Development projects in Germany',
  BUSINESS_ADMIN_PROD_FR: 'You have the right to edit all project information in Development projects in France',
  BUSINESS_ADMIN_PROD_IT: 'You have the right to edit all project information in Development projects in Italy',
  BUSINESS_ADMIN_PROD_AU: 'You have the right to edit all project information in Development projects in Australia',
  BUSINESS_ADMIN_PROD_PL: 'You have the right to edit all project information in Development projects in Poland',
  BUSINESS_ADMIN_PROD_GB: 'You have the right to edit all project information in Development projects in the United Kingdom',
  BUSINESS_ADMIN_PROD_NL: 'You have the right to edit all project information in Development projects in the Netherlands',
  BUSINESS_ADMIN_PROD_ES: 'You have the right to edit all project information in Development projects in Spain',
  BUSINESS_ADMIN_PROD_IE: 'You have the right to edit all project information in Development projects in Ireland',
  BUSINESS_ADMIN_UAT_DE: 'You have the right to edit all project information in Development projects in Germany',
  BUSINESS_ADMIN_UAT_FR: 'You have the right to edit all project information in Development projects in France',
  BUSINESS_ADMIN_UAT_IT: 'You have the right to edit all project information in Development projects in Italy',
  BUSINESS_ADMIN_UAT_AU: 'You have the right to edit all project information in Development projects in Australia',
  BUSINESS_ADMIN_UAT_PL: 'You have the right to edit all project information in Development projects in Poland',
  BUSINESS_ADMIN_UAT_GB: 'You have the right to edit all project information in Development projects in the United Kingdom',
  BUSINESS_ADMIN_UAT_NL: 'You have the right to edit all project information in Development projects in the Netherlands',
  BUSINESS_ADMIN_UAT_ES: 'You have the right to edit all project information in Development projects in Spain',
  BUSINESS_ADMIN_UAT_IE: 'You have the right to edit all project information in Development projects in Ireland',
  BUSINESS_ADMIN_TEST_ANY: 'You have the right to edit all project information in Development projects',
  COUNTRY_READING_AU: 'You have the right to read all project information in projects in Australia',
  COUNTRY_READING_FR: 'You have the right to read all project information in projects in France',
  COUNTRY_READING_DE: 'You have the right to read all project information in projects in Germany',
  COUNTRY_READING_GR: 'You have the right to read all project information in projects in Greece',
  COUNTRY_READING_IE: 'You have the right to read all project information in projects in Ireland',
  COUNTRY_READING_IT: 'You have the right to read all project information in projects in Italy',
  COUNTRY_READING_NL: 'You have the right to read all project information in projects in Netherlands',
  COUNTRY_READING_PL: 'You have the right to read all project information in projects in Poland',
  COUNTRY_READING_ES: 'You have the right to read all project information in projects in Spain',
  COUNTRY_READING_SE: 'You have the right to read all project information in projects in Sweden',
  COUNTRY_READING_GB: 'You have the right to read all project information in projects in United Kingdom',
  BINARY_ASSESSMENT_READING_AU: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.AU].name}`,
  BINARY_ASSESSMENT_WRITING_AU: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.AU].name}`,
  BINARY_ASSESSMENT_READING_FR: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.FR].name}`,
  BINARY_ASSESSMENT_WRITING_FR: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.FR].name}`,
  BINARY_ASSESSMENT_READING_DE: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.DE].name}`,
  BINARY_ASSESSMENT_WRITING_DE: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.DE].name}`,
  BINARY_ASSESSMENT_READING_GR: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.GR].name}`,
  BINARY_ASSESSMENT_WRITING_GR: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.GR].name}`,
  BINARY_ASSESSMENT_READING_IE: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.IE].name}`,
  BINARY_ASSESSMENT_WRITING_IE: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.IE].name}`,
  BINARY_ASSESSMENT_READING_IT: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.IT].name}`,
  BINARY_ASSESSMENT_WRITING_IT: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.IT].name}`,
  BINARY_ASSESSMENT_READING_NL: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.NL].name}`,
  BINARY_ASSESSMENT_WRITING_NL: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.NL].name}`,
  BINARY_ASSESSMENT_READING_PL: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.PL].name}`,
  BINARY_ASSESSMENT_WRITING_PL: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.PL].name}`,
  BINARY_ASSESSMENT_READING_ES: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.ES].name}`,
  BINARY_ASSESSMENT_WRITING_ES: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.ES].name}`,
  BINARY_ASSESSMENT_READING_SE: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.SE].name}`,
  BINARY_ASSESSMENT_WRITING_SE: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.SE].name}`,
  BINARY_ASSESSMENT_READING_GB: `You have the right to view the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.GB].name}`,
  BINARY_ASSESSMENT_WRITING_GB: `You have the right to view and change the Binary Assessment for all projects in ${BY_ALPHA_2[CountryAlpha2Code.GB].name}`,
}

export function countryToBusinessAdminProd(countryCode: CountryAlpha2Code): FncGroup | null {
  switch (countryCode) {
    case CountryAlpha2Code.DE: return FncGroup.BUSINESS_ADMIN_PROD_DE;
    case CountryAlpha2Code.FR: return FncGroup.BUSINESS_ADMIN_PROD_FR;
    case CountryAlpha2Code.IT: return FncGroup.BUSINESS_ADMIN_PROD_IT;
    case CountryAlpha2Code.AU: return FncGroup.BUSINESS_ADMIN_PROD_AU;
    case CountryAlpha2Code.PL: return FncGroup.BUSINESS_ADMIN_PROD_PL;
    case CountryAlpha2Code.GB: return FncGroup.BUSINESS_ADMIN_PROD_GB;
    case CountryAlpha2Code.NL: return FncGroup.BUSINESS_ADMIN_PROD_NL;
    case CountryAlpha2Code.ES: return FncGroup.BUSINESS_ADMIN_PROD_ES;
    case CountryAlpha2Code.IE: return FncGroup.BUSINESS_ADMIN_PROD_IE;
  }
  return null;
}

export function countryToBusinessAdminUat(countryCode: CountryAlpha2Code): FncGroup | null {
  switch (countryCode) {
    case CountryAlpha2Code.DE: return FncGroup.BUSINESS_ADMIN_UAT_DE;
    case CountryAlpha2Code.FR: return FncGroup.BUSINESS_ADMIN_UAT_FR;
    case CountryAlpha2Code.IT: return FncGroup.BUSINESS_ADMIN_UAT_IT;
    case CountryAlpha2Code.AU: return FncGroup.BUSINESS_ADMIN_UAT_AU;
    case CountryAlpha2Code.PL: return FncGroup.BUSINESS_ADMIN_UAT_PL;
    case CountryAlpha2Code.GB: return FncGroup.BUSINESS_ADMIN_UAT_GB;
    case CountryAlpha2Code.NL: return FncGroup.BUSINESS_ADMIN_UAT_NL;
    case CountryAlpha2Code.ES: return FncGroup.BUSINESS_ADMIN_UAT_ES;
    case CountryAlpha2Code.IE: return FncGroup.BUSINESS_ADMIN_UAT_IE;
  }
  return null;
}

export function countryToBusinessAdminOther(_: CountryAlpha2Code): FncGroup | null {
  return FncGroup.BUSINESS_ADMIN_TEST_ANY;
}

export const envToBusinessAdminMap: Record<DigiResEnvironmentName, (cc: CountryAlpha2Code) => FncGroup | null> = {
  local: countryToBusinessAdminOther,
  docker: countryToBusinessAdminOther,
  debug: countryToBusinessAdminOther,
  test: countryToBusinessAdminOther,
  'preview-alpha': countryToBusinessAdminOther,
  'preview-beta': countryToBusinessAdminOther,
  staging: countryToBusinessAdminUat,
  production: countryToBusinessAdminProd,
};

export function countryToReadingAccess(countryCode: CountryAlpha2Code): FncGroup | null {
  switch (countryCode) {
    case CountryAlpha2Code.AU: return FncGroup.COUNTRY_READING_AU;
    case CountryAlpha2Code.FR: return FncGroup.COUNTRY_READING_FR;
    case CountryAlpha2Code.DE: return FncGroup.COUNTRY_READING_DE;
    case CountryAlpha2Code.GR: return FncGroup.COUNTRY_READING_GR;
    case CountryAlpha2Code.IE: return FncGroup.COUNTRY_READING_IE;
    case CountryAlpha2Code.IT: return FncGroup.COUNTRY_READING_IT;
    case CountryAlpha2Code.NL: return FncGroup.COUNTRY_READING_NL;
    case CountryAlpha2Code.PL: return FncGroup.COUNTRY_READING_PL;
    case CountryAlpha2Code.ES: return FncGroup.COUNTRY_READING_ES;
    case CountryAlpha2Code.SE: return FncGroup.COUNTRY_READING_SE;
    case CountryAlpha2Code.GB: return FncGroup.COUNTRY_READING_GB;
  }
  return null;
}

export const BINARY_ASSESSMENT_FNC_GROUPS: FncGroup[] = Object.values(CountryAlpha2Code)
  .filter(countryCode => !!countryToBinaryAssessmentReading(countryCode))
  .flatMap(countryCode => [countryToBinaryAssessmentReading(countryCode), countryToBinaryAssessmentWriting(countryCode)]);

export function countryToBinaryAssessmentReading(countryCode: CountryAlpha2Code): FncGroup | null {
  switch (countryCode) {
    case CountryAlpha2Code.AU: return FncGroup.BINARY_ASSESSMENT_READING_AU;
    case CountryAlpha2Code.FR: return FncGroup.BINARY_ASSESSMENT_READING_FR;
    case CountryAlpha2Code.DE: return FncGroup.BINARY_ASSESSMENT_READING_DE;
    case CountryAlpha2Code.GR: return FncGroup.BINARY_ASSESSMENT_READING_GR;
    case CountryAlpha2Code.IE: return FncGroup.BINARY_ASSESSMENT_READING_IE;
    case CountryAlpha2Code.IT: return FncGroup.BINARY_ASSESSMENT_READING_IT;
    case CountryAlpha2Code.NL: return FncGroup.BINARY_ASSESSMENT_READING_NL;
    case CountryAlpha2Code.PL: return FncGroup.BINARY_ASSESSMENT_READING_PL;
    case CountryAlpha2Code.ES: return FncGroup.BINARY_ASSESSMENT_READING_ES;
    case CountryAlpha2Code.SE: return FncGroup.BINARY_ASSESSMENT_READING_SE;
    case CountryAlpha2Code.GB: return FncGroup.BINARY_ASSESSMENT_READING_GB;
  }
  return null;
}

export function countryToBinaryAssessmentWriting(countryCode: CountryAlpha2Code): FncGroup | null {
  switch (countryCode) {
    case CountryAlpha2Code.AU: return FncGroup.BINARY_ASSESSMENT_WRITING_AU;
    case CountryAlpha2Code.FR: return FncGroup.BINARY_ASSESSMENT_WRITING_FR;
    case CountryAlpha2Code.DE: return FncGroup.BINARY_ASSESSMENT_WRITING_DE;
    case CountryAlpha2Code.GR: return FncGroup.BINARY_ASSESSMENT_WRITING_GR;
    case CountryAlpha2Code.IE: return FncGroup.BINARY_ASSESSMENT_WRITING_IE;
    case CountryAlpha2Code.IT: return FncGroup.BINARY_ASSESSMENT_WRITING_IT;
    case CountryAlpha2Code.NL: return FncGroup.BINARY_ASSESSMENT_WRITING_NL;
    case CountryAlpha2Code.PL: return FncGroup.BINARY_ASSESSMENT_WRITING_PL;
    case CountryAlpha2Code.ES: return FncGroup.BINARY_ASSESSMENT_WRITING_ES;
    case CountryAlpha2Code.SE: return FncGroup.BINARY_ASSESSMENT_WRITING_SE;
    case CountryAlpha2Code.GB: return FncGroup.BINARY_ASSESSMENT_WRITING_GB;
  }
  return null;
}
